export const touchState = () => {
    return {
        hasTouch: ('ontouchstart' in window) || (navigator.maxTouchPoints > 0),
        hasMouseSupport: window.matchMedia('(hover: hover) and (pointer: fine)').matches
    }
};